import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=11d70a50&"
import script from "./FilesUpload.vue?vue&type=script&lang=js&"
export * from "./FilesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports